import { getFadeColor } from '@repo/toolkit/colors'
import { DateFormatter } from '@repo/toolkit/date'
import Badge, { BadgeProps } from '@repo/ui/badge'

import useTranslate from '../../lib/hooks/use-translate'
import { PeriodTypes } from '../../lib/types/models/period/period'
import { getLocalizedLabel } from '../../utils/functions/get-localized-label'

type Props = BadgeProps & {
  period?: PeriodTypes.Basic
  dateDisplay?: Date
}

const PeriodBadge: React.FC<Props> = ({ text, period, dateDisplay, ...props }) => {
  const { currentLanguage } = useTranslate()

  const name = !period
    ? ''
    : getLocalizedLabel(period, currentLanguage, { fr: 'name', en: 'nameEn' })
  return (
    <Badge
      {...props}
      text={text ?? (dateDisplay ? `${DateFormatter.DDMMYYYY(dateDisplay)} ${name}` : name)}
      color={period?.color ? getFadeColor(period?.color) : undefined}
      textColor={period?.color}
      size={'small'}
    />
  )
}

export default PeriodBadge
